/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useEffect, useMemo, useRef } from 'react';
import { StorageClient } from '@atlaskit/frontend-utilities/storage-client';
import { getPulseStyles } from './styled';
var LOCAL_STORAGE_CLIENT_KEY = '@atlaskit/smart-card';
var LOCAL_STORAGE_DISCOVERY_KEY = 'action-discovery-ai-summarise';
var LOCAL_STORAGE_DISCOVERY_VALUE = 'discovered';
var LOCAL_STORAGE_DISCOVERY_EXPIRY_IN_MS = 15552000000; // 180 days
var LOCAL_STORAGE_DISCOVERY_REQUIRED_TIME = 2000;
/**
 * This is a hacky solution to help with the feature discovery.
 * This implementation must be removed once the experiment is completed.
 * Cleanup on https://product-fabric.atlassian.net/browse/EDM-9649
 */
var FeatureDiscovery = function FeatureDiscovery(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  var renderedTime = useRef();
  var storageClient = useMemo(function () {
    return new StorageClient(LOCAL_STORAGE_CLIENT_KEY);
  }, []);
  var discovered = useMemo(function () {
    return storageClient.getItem(LOCAL_STORAGE_DISCOVERY_KEY) === LOCAL_STORAGE_DISCOVERY_VALUE;
  }, [storageClient]);
  useEffect(function () {
    renderedTime.current = Date.now();
    return function () {
      if (!discovered && renderedTime.current) {
        var duration = Date.now() - renderedTime.current;
        if (duration > LOCAL_STORAGE_DISCOVERY_REQUIRED_TIME) {
          storageClient.setItemWithExpiry(LOCAL_STORAGE_DISCOVERY_KEY, LOCAL_STORAGE_DISCOVERY_VALUE, LOCAL_STORAGE_DISCOVERY_EXPIRY_IN_MS);
        }
      }
    };
  }, [storageClient, discovered]);
  var component = useMemo(function () {
    if (!discovered) {
      return jsx("span", {
        css: getPulseStyles(),
        "data-testid": "".concat(testId, "-discovery")
      }, children);
    }
  }, [children, discovered, testId]);
  return component !== null && component !== void 0 ? component : children;
};
export default FeatureDiscovery;